export enum ECalendarTasksForm {
  delegatedTasks = 'delegatedTasks',
  myTasks = 'myTasks',
  otherTasks = 'otherTasks',
}
